<template>
  <div>
    <h3 class="h5 mb-2">Preguntas que te pueden interesar</h3>
    <ul class="list-unstyled w-100">
      <li v-for="(q, i) in questions" :key="i" class="predefined-question w-100">
        <a href="#" @click.prevent="$emit('select', q)" class="predefined-question-text w-100">{{ q }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PredefinedQuestions',
  props: {
    questions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.predefined-question {
  background: rgba(234, 247, 255, 1);
  padding: 0.8rem;
  margin-bottom: 8px;
  cursor: pointer;
  border-radius: 15px;
}
.predefined-question-text {
  color: rgba(110, 107, 123, 1);
}
.predefined-question:hover {
  color: rgba(110, 107, 123, 1);
  background: rgba(234, 247, 255, 0.75);
}
.predefined-question-text:hover {
  color: rgba(50, 173, 236, 1);
}
</style>